export var ReferralStatus;
(function (ReferralStatus) {
    ReferralStatus["SIGNED_UP"] = "SIGNED_UP";
    ReferralStatus["KYC_PENDING"] = "KYC_PENDING";
    ReferralStatus["KYC_COMPLETED"] = "KYC_COMPLETED";
    ReferralStatus["QUALIFYING"] = "QUALIFYING";
    ReferralStatus["QUALIFIED"] = "QUALIFIED";
    ReferralStatus["REWARDED"] = "REWARDED";
    ReferralStatus["REJECTED"] = "REJECTED";
    ReferralStatus["EXPIRED"] = "EXPIRED";
})(ReferralStatus || (ReferralStatus = {}));
export const REFERRAL_QUALIFIED_STATUSES = [ReferralStatus.QUALIFIED, ReferralStatus.REWARDED];
export const REFERRAL_PENDING_STATUSES = [
    ReferralStatus.SIGNED_UP,
    ReferralStatus.KYC_PENDING,
    ReferralStatus.KYC_COMPLETED,
    ReferralStatus.QUALIFYING,
];
export const REFERRAL_TERMINAL_STATUSES = [
    ReferralStatus.REWARDED,
    ReferralStatus.REJECTED,
    ReferralStatus.EXPIRED,
];
export var RewardStatus;
(function (RewardStatus) {
    RewardStatus["PENDING_QUALIFICATION"] = "PENDING_QUALIFICATION";
    RewardStatus["AUTO_APPROVED"] = "AUTO_APPROVED";
    RewardStatus["PENDING_ACCOUNT"] = "PENDING_ACCOUNT";
    RewardStatus["DISTRIBUTED"] = "DISTRIBUTED";
    RewardStatus["FAILED"] = "FAILED";
    RewardStatus["REJECTED"] = "REJECTED";
})(RewardStatus || (RewardStatus = {}));
export var ReferralRole;
(function (ReferralRole) {
    ReferralRole["REFERRER"] = "REFERRER";
    ReferralRole["REFEREE"] = "REFEREE";
})(ReferralRole || (ReferralRole = {}));
export var ReferralConfigAction;
(function (ReferralConfigAction) {
    ReferralConfigAction["UPDATE"] = "UPDATE";
    ReferralConfigAction["PAUSE"] = "PAUSE";
    ReferralConfigAction["UNPAUSE"] = "UNPAUSE";
    ReferralConfigAction["FORCE_QUALIFY"] = "FORCE_QUALIFY";
})(ReferralConfigAction || (ReferralConfigAction = {}));
//# sourceMappingURL=referral.types.js.map